import { Dropdown } from 'react-bootstrap'
import CustomToolTip from '../../CommonComponents/CustomToolTip'
import useGeoFeatures from '../hooks/useGeoFeatures'
import { GeoFenceIcon, PlusSvg, TargetTrackIcon, UploadSvg } from '../Svgs'
import './FeatureListView.scss'
import Loader from '../../../Layouts/Loader/Loader'
import { Fragment } from 'react'
import { downloadAsShapefile } from '../utils/utilities'

export const MENU_ITEMS = ['Edit', 'Delete', 'Export']

const FeatureListView = () => {
    const { geoFeaturesDetails, toggleViewMode, setSidebarOpen, actionFeature, onMenuClick, setSelectedFeature } = useGeoFeatures()
    const { loading, allFeatures } = geoFeaturesDetails

    return (
        <Fragment>
            {loading && <Loader />}
            <div className='feature__list__view__container'>
                {allFeatures?.length === 0 &&
                    <button className='feature__button large'
                        onClick={() => actionFeature('Create')}
                    >
                        <PlusSvg />
                        Create GeoFeature
                    </button>
                }
                {allFeatures?.length > 0 &&
                    <div className='feature__list__view__container__header'>
                        <CustomToolTip title='Export All' placement='bottom'>
                            <button
                                className={`feature__button export`}
                                onClick={() => { downloadAsShapefile(allFeatures) }}
                            >
                                <UploadSvg />
                            </button>
                        </CustomToolTip>
                        <CustomToolTip title='List View'>
                            <button className='feature__button small'>
                                <img src={require('../../../assets/images/svgs/gs/list_selected.svg').default} height={35} alt="map" />
                            </button>
                        </CustomToolTip>
                        <CustomToolTip title='Map View'>
                            <button className='feature__button small me-2'
                                onClick={() => {
                                    setSelectedFeature(null)
                                    setSidebarOpen(true)
                                    toggleViewMode()
                                }}
                            >
                                <img src={require('../../../assets/images/svgs/gs/map.svg').default} height={35} alt="map" />
                            </button>
                        </CustomToolTip>
                        <button className='feature__button'
                            onClick={() => actionFeature('Create')}
                        >
                            <PlusSvg />
                            Create New
                        </button>
                    </div>
                }
                {allFeatures?.length > 0 &&
                    <div className='feature__list__table__view__container'>
                        <div className='feature__list__table__row feature__row__header'>
                            <div className='feature__table__cell w-45'>TITLE</div>
                            <div className='feature__table__cell w-50'>DESCRIPTION</div>
                            <div className='feature__table__cell w-5 justify-content-end'></div>
                        </div>
                        <div className='d-flex flex-column gap-2'>
                            {allFeatures.map((item) => (
                                <div className='feature__list__table__row feature__row__body' key={item?.areaOfInterestId}>
                                    <div className='feature__table__cell w-45'>
                                        <div className='d-flex align-items-center gap-2 w-100'>
                                            {item?.type === 'Geofence' && <GeoFenceIcon />}
                                            {item?.type === 'Target Track' && <TargetTrackIcon />}
                                            <div className='w-90 text-truncate'>
                                                <CustomToolTip title={item.name}>
                                                    {item.name}
                                                </CustomToolTip>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-truncate w-50'>
                                        <CustomToolTip title={item.description}>
                                            {item.description || 'N/A'}
                                        </CustomToolTip>
                                    </div>
                                    <div className='feature__table__cell w-5 justify-content-end'>
                                        <div className="btn-list more-button">
                                            <Dropdown id="sat_edit_delete_btn" drop="end">
                                                <Dropdown.Toggle size="sm" variant="transparent">
                                                    <i className="fe fe-more-vertical fs-20"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {MENU_ITEMS.map(btn => (
                                                        <Dropdown.Item eventKey={btn} id={btn} key={btn}
                                                            onClick={() => {
                                                                onMenuClick(btn, item)
                                                            }}>
                                                            {btn}
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                }
            </div>
        </Fragment>
    )
}

export default FeatureListView